import { Card, CardContent, Typography, Box } from '@mui/material';
import CustomPopper from './custom-popper.component';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import moment from 'moment';

const CustomCard = ({ menuItems, module, onClick  }) => {
    const formattedDate = moment(module.updated_at).format('MMMM Do YYYY, h:mm:ss a');
    return (
        <Card sx={{ height: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1, marginBottom: '2%' }}>
                <CustomPopper row={module}  icon={MoreHorizIcon} menuItems={menuItems}/>
            </Box>
            <CardContent sx={{ display: 'flex', alignItems: 'center', p: 2, marginBottom:'2%' }}  onClick={onClick}>
                <Box
                    sx={{
                        width: '20%', 
                        aspectRatio: '1', 
                        borderRadius: '50%',
                        backgroundColor: '#f5f5f5',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: 2,
                    }}
                >
                    <Typography variant="h3" sx={{ fontSize: '2rem'}}>
                        {module.module_name.substring(0, 2)}
                    </Typography>
                </Box>
                <Box sx={{ width: '80%' }}>
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {module.module_name.replace(/\s+/g, '_').toUpperCase()}
                    </Typography>
                </Box>
            </CardContent>
            <Box sx={{ p: 2, textAlign:"right" }}>
                <Typography variant="caption" color="textSecondary" >
                    Last date modified: {formattedDate}
                </Typography>
            </Box>
        </Card>
    );
};
export default CustomCard;
